package com.siriusxm.pia.rest.unifiedaggregator

import com.siriusxm.cmc.utils.CMCImages
import com.siriusxm.cmc.utils.ImageFormat
import com.siriusxm.cmc.utils.ResizeParams
import contentingestion.unifiedmodel.ImageAspectRatio
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import kotlin.io.encoding.ExperimentalEncodingApi
import kotlin.math.min

object ImageRenderingHelper {
    @OptIn(ExperimentalSerializationApi::class)
    val json = Json {
        explicitNulls = false
    }

    @OptIn(ExperimentalEncodingApi::class)
    fun getImageUrl(baseUrl: String, path: String, resize: ResizeParams? = null, format: ImageFormat? = null): String {
        return CMCImages.getImageUrl(baseUrl, path, resize, format)
    }

    fun getImageWidth(aspectRatio: ImageAspectRatio, srcImageWidth: Int?, srcImageHeight: Int?, maxHeight: Int, maxWidth: Int) : Int {
        return when (aspectRatio) {
            ImageAspectRatio.ASPECT_1X1 -> maxWidth
            ImageAspectRatio.ASPECT_16X9 -> getRatiodWidth(16, 9, 250, 250)
            ImageAspectRatio.ASPECT_5X4 -> getRatiodWidth(5, 4, 250, 250)
            else -> maxWidth
        }
    }

    fun getImageHeight(aspectRatio: ImageAspectRatio, srcImageWidth: Int?, srcImageHeight: Int?, maxHeight: Int, maxWidth: Int) : Int {
        return when (aspectRatio) {
            ImageAspectRatio.ASPECT_1X1 -> maxHeight
                ImageAspectRatio.ASPECT_16X9 -> getRatiodHeight(16, 9, 250, 250)
            ImageAspectRatio.ASPECT_5X4 -> getRatiodHeight(5, 4, 250, 250)
            else -> maxWidth
        }
    }

    private fun getRatiodWidth(widthRatio: Int, heightRatio: Int, maxWidth: Int, maxHeight: Int) : Int {
        return if (widthRatio == heightRatio) {
            maxWidth
        } else if (widthRatio > heightRatio) {
            maxWidth
        } else {
            min(((widthRatio * maxWidth) / heightRatio) * maxWidth, maxWidth)
        }
    }

    private fun getRatiodHeight(widthRatio: Int, heightRatio: Int, maxWidth: Int, maxHeight: Int) : Int {
        return if (widthRatio == heightRatio) {
            maxWidth
        } else if (widthRatio > heightRatio) {
            min(((heightRatio * maxHeight) / widthRatio) * maxHeight, maxHeight)
        } else {
            maxHeight
        }
    }
}


@Serializable
data class ImageSpec(
    val key: String,
    val edits: List<Map<String, ImageParams>>? = null
)

@Serializable
data class ImageParams(
    val width: Int? = null,
    val height: Int? = null,
    val type: String? = null
)